import { apiService } from "@/services/apiService";

export const productRepo = {
  getForMunicipality: async (municipalityId: string) => {
    const product = await apiService.v1.createProductPrice({
      municipalityIdExtended: municipalityId,
    });
    return product.data;
  },
};
